import { render, staticRenderFns } from "./backOrder.vue?vue&type=template&id=d1d2d84c&scoped=true&"
import script from "./backOrder.vue?vue&type=script&lang=js&"
export * from "./backOrder.vue?vue&type=script&lang=js&"
import style0 from "./backOrder.vue?vue&type=style&index=0&id=d1d2d84c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d2d84c",
  null
  
)

export default component.exports